import { render, staticRenderFns } from "./Offers3.vue?vue&type=template&id=be80d018&scoped=true&"
import script from "./Offers3.vue?vue&type=script&lang=js&"
export * from "./Offers3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be80d018",
  null
  
)

export default component.exports